module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAANdJREFUSEu9lusRwiAQhDcdaQV2YwdWYQd2Ywd2pHMGMidzj4VI+JMHx36E24MsABYAJ6ztBeBd7kcvP3rycAZwK2pPAI8dENG7ArgUvXsLkPejkFZctL4Aq6MX4mpIh7Q9kHBsBYxC0olpQC8kFa+CrR2ZgUzMtvaW3yMBiddWDJ3XLpGGeRCJqT5PbR0BvJzoSaR2zgARJBX3kswkPV2aKpJ9gZWHvy3R1CRPtSlTREyMWWj0QHaDPGyz65k5Y+OtRg45cPSZTBeQsUO6R+b0Q1/I035bPsczbuHJptkAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verify-close.png
// module id = G/kx
// module chunks = 9